/**
 * Swaps a video facade for the real YouTube player on click.
 *
 * snippets/product-description.liquid replaces each YouTube iframe in a
 * product description with a poster image and a play button, so nothing is
 * fetched from YouTube on page load (2 MB and 30 requests per view, measured,
 * with consent denied). This inserts the player only when a shopper asks for
 * it. Delegated on the document because descriptions are section content
 * and, per AGENTS.md, scripts inside injected fragments do not run.
 *
 * The iframe is built here, after theme.js has finished with the page, so its
 * wrapVideo (which resets iframe.src and re-inserts the element, reloading it
 * twice) never sees it. youtube-nocookie.com is the privacy-enhanced embed
 * host; autoplay is set because the shopper just clicked play.
 *
 * Without JavaScript the facade is a plain link to the player on
 * youtube-nocookie.com -- see video-facade.liquid for why it is that host and
 * not a youtube.com/watch URL.
 *
 * The listener is on the CAPTURE phase and stops the event dead. Stock
 * theme.videoModal() binds triggerYouTubeModal directly to any element
 * matching its own YouTube selector, and a listener on the element beats a
 * delegated one on the document -- Modals.open then calls stopPropagation, so
 * this handler never ran and the theme's modal played the video from
 * www.youtube.com instead. The href no longer matches that selector, which is
 * the actual fix; capture is the belt to its braces, so that a merchant
 * pasting a bare YouTube link into the same description cannot resurrect the
 * hijack. Nothing else in the theme wants a click on a facade, so swallowing
 * it here costs nothing.
 */
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-video-facade]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    var id = link.getAttribute('data-video-id');
    if (!id) return;

    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    iframe.title = link.getAttribute('data-video-title') || 'Video';
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');

    link.replaceWith(iframe);
    iframe.focus();
  }, true);
})();
